import { createFileRoute } from "@tanstack/react-router";
import ThankYouMeeting from "@/pages/ThankYouMeeting";

export const Route = createFileRoute("/thank-you/meeting")({
  component: ThankYouMeeting,
});
